"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const h = ({
  title: c,
  titleId: i,
  desc: a,
  descId: e,
  ...d
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ca",
    viewBox: "0 0 640 480",
    "aria-labelledby": i,
    "aria-describedby": e,
    ...d,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: e, children: a }) : null,
      c ? /* @__PURE__ */ l("title", { id: i, children: c }) : null,
      /* @__PURE__ */ l("path", { fill: "#fff", d: "M150.1 0h339.7v480H150z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#d52b1e",
          d: "M-19.7 0h169.8v480H-19.7zm509.5 0h169.8v480H489.9zM201 232l-13.3 4.4 61.4 54c4.7 13.7-1.6 17.8-5.6 25l66.6-8.4-1.6 67 13.9-.3-3.1-66.6 66.7 8c-4.1-8.7-7.8-13.3-4-27.2l61.3-51-10.7-4c-8.8-6.8 3.8-32.6 5.6-48.9 0 0-35.7 12.3-38 5.8l-9.2-17.5-32.6 35.8c-3.5.9-5-.5-5.9-3.5l15-74.8-23.8 13.4c-2 .9-4 .1-5.2-2.2l-23-46-23.6 47.8c-1.8 1.7-3.6 1.9-5 .7L264 130.8l13.7 74.1c-1.1 3-3.7 3.8-6.7 2.2l-31.2-35.3c-4 6.5-6.8 17.1-12.2 19.5-5.4 2.3-23.5-4.5-35.6-7 4.2 14.8 17 39.6 9 47.7"
        }
      )
    ]
  }
);
export {
  h as default
};
